<template>
  <div class="humanlist">
    <slot>
    <table-c>
      <tr-c slot="tr-th">
        <th-c @click='sort("id")'>ID</th-c>
        <th-c>名前</th-c>
        <th-c>読み</th-c>
        <th-c>住所</th-c>
        <th-c>電話番号</th-c>
        <th-c @click='sort("created_at")'>登録日</th-c>
      </tr-c>
      <tr-c slot="tr-td" v-for="(list, index) in lists" :key="index.id" v-link="{ name: 'name', params: { id: list.id }}" class="tr_hover">
        <td-c>{{list.id}}</td-c>
        <td-c>{{list.f_name}} {{list.l_name}}</td-c>
        <td-c>{{list.f_name_kana}} {{list.l_name_kana}}</td-c>
        <td-c>{{list.pref}}{{list.address1}}{{list.address2}}</td-c>
        <td-c>{{list.tel1}}</td-c>
        <td-c>{{list.created_at.substring(0, 10)}}</td-c>
      </tr-c>
    </table-c>
    </slot>
  </div>
</template>

<script>
export default {
  props: ['lists', 'name'],
  vuex: {
    getters: {

    }
  },
  data () {
    return {

    }
  },
  computed: {

  },
  methods: {

  },
  mounted () {

  }
}
</script>

<style lang='scss' scoped>

</style>



// WEBPACK FOOTER //
// HumanList.vue?617166fb